import customAxios from "./axiosConfig";

const SubscriptionService = {
    list: function (params) {
        var api_url = window.Urls['subscription_list']();
        return customAxios.get(api_url, {params: params});
    },
    retrieveCurrent: function (params) {
        var api_url = window.Urls['subscription-detail'](1); //the id does not matter as the backend will retrieve your own subscription
        return customAxios.get(api_url, {params: params});
    },
    update: function (pk, data) {
        var api_url = window.Urls['subscription-detail'](pk);
        return customAxios.put(api_url, data);
    },
    getPaymentMethods: function (pk) { // billing setting id
        var api_url = window.Urls['subscription-payment-details'](pk);
        return customAxios.get(api_url);
    },
    cancelSubscription: function (pk, data) {
        var api_url = window.Urls['subscription_cancel_subscription'](pk);
        return customAxios.post(api_url, data);
    },
    undoCancelSubscription: function (pk) {
        var api_url = window.Urls['subscription_undo_cancel_subscription'](pk);
        return customAxios.get(api_url);
    },
    deactivatePaymentMethod: function (pk, data) {
        var api_url = window.Urls['subscription_remove_payment_details'](pk);
        return customAxios.post(api_url, data);
    }
};

export default SubscriptionService;
